import { FormattedMessage, useIntl } from 'react-intl';
import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../../common/button-new';
import { InternalLinks } from '../../../../../constants';
import { ErrorModal } from '../error-modal';
import { useQuery } from '@apollo/client';
import { GET_DEPENDENTS_COUNTER } from '../../../../../graphql/profile/queries';
import { DEPENDENTS_LIMIT } from '../../../../../constants/profile';

export const AddProfile = ({ rootClasses }: { rootClasses?: string }): JSX.Element => {
  const intl = useIntl();
  const { showModal } = useModal();
  const navigate = useNavigate();
  const { data, error } = useQuery<{ profile: { dependentsCounter: number } }>(GET_DEPENDENTS_COUNTER);
  const isOverlimit = !!data?.profile?.dependentsCounter
    && (data?.profile?.dependentsCounter === DEPENDENTS_LIMIT || data?.profile?.dependentsCounter > DEPENDENTS_LIMIT );

  const handleAdd = () => {
    if (error || isOverlimit) {
      showModal(ErrorModal, {
        title: 'addKidsProfile.error.title',
        text: 'addKidsProfile.error.text',
        firstButton: 'common.errors.callSupport',
        secondButton: 'common.gotIt',
        firstButtonUrl: intl.formatMessage({ id: 'common.phoneNumber.support.href' }),
      });
    } else {
      navigate(InternalLinks.createProfile);
    }
  };

  return (
    <Button
      onClick={handleAdd}
      rootClasses={rootClasses}
      style="dark"><FormattedMessage
      id="kidsProfile.add"
    /></Button>
  );
};
